import { Link } from 'react-router-dom';
import type { ComicItem } from '@/mocks/home';

interface FeaturedComicsProps {
  comics: ComicItem[];
}

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`text-xs w-3 h-3 flex items-center justify-center ${
            star <= Math.round(rating / 2)
              ? 'ri-star-fill text-primary-500'
              : 'ri-star-line text-foreground-300'
          }`}
        ></i>
      ))}
      <span className="text-xs font-semibold text-primary-600 ml-1">{rating}</span>
    </div>
  );
}

export default function FeaturedComics({ comics }: FeaturedComicsProps) {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              推荐漫画
            </h2>
            <p className="mt-2 text-sm text-foreground-500">精选高品质韩国漫画，好评如潮</p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {comics.slice(0, 5).map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group block"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={`${comic.title} - 韩漫在线观看`}
                  title={`${comic.title} - 韩漫在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-primary-500 text-background-50">
                    {comic.rating}
                  </span>
                </div>
                {comic.status === '连载中' && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent-500 text-background-50">
                      连载
                    </span>
                  </div>
                )}
                {comic.status === '已完结' && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-foreground-700 text-background-50">
                      完结
                    </span>
                  </div>
                )}
              </div>
              <h3 className="mt-3 text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <div className="mt-1.5 flex items-center justify-between">
                <span className="text-xs text-foreground-500">{comic.author}</span>
                <StarRating rating={comic.rating} />
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap"
          >
            查看全部推荐 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}